import React from "react"
import { AppModal } from "@components"
import { dsColorNew } from "@palette"
import { isOpenProvidersSuppliersMappingModal } from "Pages/Admin/ProvidersSuppliersMapping/@signals"
import { Box, Chip, Divider, Grid, Typography } from "@mui/material"
import NormalizeField from "Pages/Admin/ProvidersSuppliersMapping/Modal/NormalizeField"


export default function ProvidersSuppliersMappingModal() {

	if (!isOpenProvidersSuppliersMappingModal.value?.length) return null


	return <AppModal
		icon="diagram-project"
		title="Edit Mappings"
		subtitle={`${isOpenProvidersSuppliersMappingModal.value.length} raw value${isOpenProvidersSuppliersMappingModal.value.length === 1 ? '' : 's'} selected`}
		isOpen={!!isOpenProvidersSuppliersMappingModal.value?.length}
		controller={() => isOpenProvidersSuppliersMappingModal.value = []}
		hideActions
	>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<Typography sx={{ fontSize: 11, fontWeight: 600, color: dsColorNew.textSubtle, textTransform: 'uppercase', letterSpacing: 0.6 }}>Selected raw data</Typography>
				<Box sx={{ display: "flex", alignItems: "center", justifyContent: "start", flexWrap: "wrap", gap: 1, my: 1 }}>
					{isOpenProvidersSuppliersMappingModal.value?.map(({ rawData }, idx) => {
						return <Chip
							size="small"
							sx={{ borderRadius: '6px', backgroundColor: dsColorNew.pillActiveBg, color: dsColorNew.appBlue, fontWeight: 500 }}
							label={rawData}
							key={`${rawData}-${idx}`}/>
					})}
				</Box>
				<Divider sx={{ my: 2 }}/>
				<Box>
					<NormalizeField/>
				</Box>
			</Grid>
		</Grid>
	</AppModal>
}